export function getTextLines(text, maxWidth, font) {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  context.font = font ? font : "16px Poppins";

  const words = text.split(" ");
  let lineCount = 1;
  let currentLineWidth = 0;

  for (let i = 0; i < words.length; i++) {
    const word = words[i];
    const wordWidth = context.measureText(word).width;
    const spaceWidth = context.measureText(" ").width;

    if (currentLineWidth + wordWidth > maxWidth) {
      lineCount++;
      currentLineWidth = wordWidth + spaceWidth;
    } else {
      currentLineWidth += wordWidth + spaceWidth;
    }
  }

  return lineCount;
}

export function isTextLongerThan(text, maxWidth, font) {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");

  context.font = font ? font : "16px Poppins";

  const textWidth = context.measureText(text).width;

  return textWidth > maxWidth;
}

export function areAnyStringsLongerThan(textArray, maxWidth, font) {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");

  context.font = font ? font : "16px Poppins";

  for (let i = 0; i < textArray.length; i++) {
    const text = textArray[i];

    const textWidth = context.measureText(text).width;

    if (textWidth > maxWidth) {
      return true;
    }
  }

  return false;
}

export const calculateLongestLabelWidth = (labels) => {
  const longestLabel = labels.reduce(
    (a, b) => (a.length > b.length ? a : b),
    "",
  );

  const calculateTextWidth = (text, font) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    context.font = font;
    const metrics = context.measureText(text);
    return metrics.width;
  };

  const font = "16px Poppins";
  const width = calculateTextWidth(longestLabel, font);
  return width;
};
